// Follow/Unfollow a user
export const toggleFollow = async (apiCall, targetProfileId) => {
  try {
    const response = await apiCall(`/api/follow/${targetProfileId}`, {
      method: 'POST',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    // ✅ No need to emit socket event - backend handles it
    return {
      success: true,
      data: data.data,
      message: data.message
    };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Toggle follow error:', error);
    }
    throw error;
  }
};

// Get followers list
export const getFollowers = async (apiCall, userId, limit = 20, cursor = null) => {
  try {
    const params = new URLSearchParams({ limit: limit.toString() });
    if (cursor) params.append('cursor', cursor);

    const response = await apiCall(`/api/follow/followers/${userId}?${params.toString()}`, {
      method: 'GET',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      followers: data.data.followers,
      nextCursor: data.data.nextCursor,
      hasMore: data.data.hasMore
    };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Get followers error:', error);
    }
    throw error;
  }
};

// Get following list
export const getFollowing = async (apiCall, userId, limit = 20, cursor = null) => {
  try {
    const params = new URLSearchParams({ limit: limit.toString() });
    if (cursor) params.append('cursor', cursor);

    const response = await apiCall(`/api/follow/following/${userId}?${params.toString()}`, {
      method: 'GET',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      following: data.data.following,
      nextCursor: data.data.nextCursor,
      hasMore: data.data.hasMore
    };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Get following error:', error);
    }
    
    throw error;
  }
};

// Get friends list (mutual follows) - no userId parameter needed
export const getFriends = async (apiCall, limit = 15, cursor = null) => {
  try {
    const params = new URLSearchParams({ limit: limit.toString() });
    if (cursor) params.append('cursor', cursor);

    const response = await apiCall(`/api/follow/friends?${params.toString()}`, {
      method: 'GET',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      friends: data.data.friends,
      nextCursor: data.data.nextCursor,
      hasMore: data.data.hasMore
    };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Get friends error:', error);
    }
    
    throw error;
  }
};